import React, { useState } from 'react';
import { Column } from 'simple-flexbox';
import { useCommonStyles } from '../../styles/commonStyles';
import PageHeader from '../../components/PageHeader';
import SearchBar from '../../components/SearchBar';
import AddCredit from 'components/CreditModel';
import ListOfCredit from '../../components/ListOfCredits';

function Credit() {
    const commonStyles = useCommonStyles();
    const [searchWord, setSearchWord] = useState('');

    const handleSearchChange = (e) => {
        setSearchWord(e.target.value);
    };

    const handleSearchClick = () => {
        // The searchWord state change will automatically trigger the search
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearchClick();
        }
    };

    return (
        <div className={commonStyles.container}>
            <PageHeader title='Credit' subtitle='Manage your platform credits' variant='gradient' />

            <div className={commonStyles.headerSection}>
                <AddCredit />
                <SearchBar
                    value={searchWord}
                    onChange={handleSearchChange}
                    onSearch={handleSearchClick}
                    onKeyDown={handleKeyDown}
                    label='Search Credits'
                    placeholder='Name or contact'
                />
            </div>

            <Column>
                <ListOfCredit searchWord={searchWord} />
            </Column>
        </div>
    );
}

export default Credit;
